export default "__VITE_ASSET__B_RBbJE4__"